// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DVCl","title":"styles_title__7u3GE"};